// Helpers for translation key
export enum translationKey {
  BannerTitle = 'HEADER.BANNER.BASELINE'
}
